import identity from 'lodash/identity';
import React, {ReactNode} from 'react';
import { FieldRendererIntersectionProps } from '../types';
import {createField} from '../helpers';

interface Props<T extends unknown>
extends FieldRendererIntersectionProps<T, HTMLParagraphElement> {
    format?: (value: T) => ReactNode;
}

/**
 * Displays a field as static text
 */
const StaticTextField = createField(
    <T extends unknown>({
        format = identity,
        className = '',
        value,
        error, label, Renderer, onValueChange, children,
        onValueSubmit, onValueReset,
        ...props
    }: Props<T>) => <p
        className={`form-control-static ${className}`}
        {...props}
    >{format(value)}</p>
);

export default StaticTextField;
